import AdminOrganizationPicklistMetadata from "./picklist/impl/AdminOrganizationPicklistMetadata";
import OrganizationTypePicklistMetadata from "./picklist/impl/OrganizationTypePicklistMetadata";
import AdminPositionPicklistMetadata from "./picklist/impl/AdminPositionPicklistMetadata";
import EmployeePicklistMetadata from "./picklist/impl/EmployeePicklistMetadata";
import AdminRolePicklistMetadata from "./picklist/impl/AdminRolePicklistMetadata";
import AdminPrivilegePicklistMetadata from "./picklist/impl/AdminPrivilegePicklistMetadata";
import AdminViewPicklistMetadata from "./picklist/impl/AdminViewPicklistMetadata";
import AdminUserGroupPicklistMetadata from "./picklist/impl/AdminUserGroupPicklistMetadata";
import ActiveInactivePicklistMetadata from "./picklist/impl/ActiveInactivePicklistMetadata";
import AdminWorkGroupPicklistMetadata from "./picklist/impl/AdminWorkGroupPicklistMetadata";
import DocumentRevisionRDPicklistMetadata from "./picklist/impl/DocumentRevisionRDPicklistMetadata";

const picklistMetadataClasses: Map<string, object> = new Map();

picklistMetadataClasses.set("AdminOrganizationPicklistMetadata", AdminOrganizationPicklistMetadata);
picklistMetadataClasses.set("OrganizationTypePicklistMetadata", OrganizationTypePicklistMetadata);
picklistMetadataClasses.set("AdminPositionPicklistMetadata", AdminPositionPicklistMetadata);
picklistMetadataClasses.set("EmployeePicklistMetadata", EmployeePicklistMetadata);
picklistMetadataClasses.set("AdminRolePicklistMetadata", AdminRolePicklistMetadata);
picklistMetadataClasses.set("AdminPrivilegePicklistMetadata", AdminPrivilegePicklistMetadata);
picklistMetadataClasses.set("AdminViewPicklistMetadata", AdminViewPicklistMetadata);
picklistMetadataClasses.set("AdminUserGroupPicklistMetadata", AdminUserGroupPicklistMetadata);
picklistMetadataClasses.set("AdminWorkGroupPicklistMetadata", AdminWorkGroupPicklistMetadata);
picklistMetadataClasses.set("ActiveInactivePicklistMetadata", ActiveInactivePicklistMetadata);
picklistMetadataClasses.set("DocumentRevisionRDPicklistMetadata", DocumentRevisionRDPicklistMetadata);

export default function PicklistMetadataClassFactory(name: string): object | undefined {
    return picklistMetadataClasses.get(name + "PicklistMetadata");
}